import { api } from 'src/boot/axios';
import { defineStore } from 'pinia';
import { TNormalizedTranslation } from 'types';
import { getResponseData } from 'utils';

type State = {
  translations: { [key: string]: string };
};

export const useTranslationsStore = defineStore('translations', {
  state: (): State => ({
    translations: {},
  }),
  actions: {
    async getTranslations() {
      const response = await api.get('/api/v1/translations');
      const data = getResponseData(response) as TNormalizedTranslation[];
      const translations: { [key: string]: string } = {};

      data.forEach((translation) => {
        translations[`${translation.group + '.' + translation.key}`] =
          translation.text;
      });

      this.translations = translations;
      return translations;
    },
  },
});
